module.exports = __webpack_public_path__ + "media/images/icon__whatsapp-f7940349cf0814e0be0255e91ab05fbd.png";